import script from "./statList.vue?vue&type=script&lang=ts&setup=true"
export * from "./statList.vue?vue&type=script&lang=ts&setup=true"

import "./statList.vue?vue&type=style&index=0&id=f129cf28&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ALLIANCE_FRONTEND1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f129cf28"]])

export default __exports__